import { render, staticRenderFns } from "./DocumentPdfReader.vue?vue&type=template&id=6494b5b8"
import script from "./DocumentPdfReader.vue?vue&type=script&lang=js"
export * from "./DocumentPdfReader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports